var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#00B483",
    d: "m14.5345,16.11215c-0.5324,0.8931 -1.564,1.4986 -2.7492,1.4986c-1.3725,0 -2.53897,-0.812 -2.96289,-1.9424l-7.26888,7.2689c-0.84453,0.8445 -0.78513,2.2731 0.13267,3.1909c0.91779,0.9178 2.34644,0.9772 3.19096,0.1327l6.84474,-6.8448l2.8488,2.8489c0.9178,0.9178 2.3465,0.9772 3.191,0.1326c0.8445,-0.8445 0.7851,-2.2731 -0.1327,-3.1909l-2.8488,-2.8488l-0.2457,-0.2457z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#00684B",
    d: "m13.67195,17.0693l7.8717,7.8717c0.9096,0.9096 2.3936,0.9003 3.3145,-0.0207c0.921,-0.9209 0.9303,-2.4049 0.0207,-3.3145l-7.372,-7.372l2.8429,-2.8428l0.0159,-0.0158c0.921,-0.921 0.9302,-2.40496 0.0207,-3.31452c-0.9096,-0.90957 -2.3936,-0.90032 -3.3145,0.02066l-0.0001,0.00002l0,-0.00007l-3.8122,3.81211c0.9714,0.5285 1.6295,1.5493 1.6295,2.722c0,0.9978 -0.4765,1.8857 -1.2171,2.4539z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#21343B",
    d: "m14.4813,12.9638l8.3244,-8.32436c0.9194,-0.91944 0.9271,-2.4025 0.0171,-3.3125c-0.91,-0.91 -2.3931,-0.90235 -3.3125,0.0171l-7.452,7.45197l-2.82461,-2.82463c-0.91,-0.91 -2.39306,-0.90235 -3.3125,0.0171c-0.91945,0.91944 -0.9271,2.4025 -0.0171,3.3125l2.82463,2.82462l0.71958,0.7196c0.5675,-0.7535 1.4645,-1.2399 2.4739,-1.2399c1.0615,0 1.9987,0.5379 2.5591,1.3585z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 3.06818,
    rx: 3.15909,
    id: "svg_9",
    cy: 14.61363,
    cx: 11.79545,
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo-icon-white.a1350d976b7be1f0fd005ddfb4ab4be0.svg";
export { ForwardRef as ReactComponent };